<template>
    <div class="landing-page">
    </div>
</template>

<script>
import { getMapRouteOrFallback } from "@/utils/mapFeature";

export default {
    name: "LandingPage",
    created() {
        // 查询是否需要登记信息
        const uInfoCollection = this.$store.getters.user_info_collection
        if (uInfoCollection && uInfoCollection.length > 0) {
            this.$router.push({name: 'register_info'})
            return
        }
        if (!this.$store.getters['appConfig/device_code']) {
            this.$router.push(getMapRouteOrFallback({
                mapEnabled: this.$store.getters['appConfig/map_enabled'],
                deviceCode: this.$store.getters['appConfig/device_code'],
                isBorrow: this.$store.getters.is_borrow,
                machinePrecheckError: this.$store.getters['appConfig/machine_precheck_error'],
            }))
            return
        }
        // 跳转到支付页面
        this.$router.push({name: 'payment_select'})
    },
};
</script>

<style lang="scss">
.landing-page {
    height: 100%;
}
</style>
